import { get, post, put, del, upload } from '@api/request';

export async function fetchTIRZS({ assessmentService }, authenticationToken) {
  const url = `${assessmentService}/assessment/tirzs`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchTIRZ(
  { assessmentService },
  authenticationToken,
  { tirzCd },
) {
  const url = `${assessmentService}/assessment/tirz/${tirzCd}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createTIRZ(
  { assessmentService },
  authenticationToken,
  { payload },
) {
  const url = `${assessmentService}/assessment/tirzs`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateTIRZ(
  { assessmentService },
  authenticationToken,
  { tirzCd, payload },
) {
  const url = `${assessmentService}/assessment/tirz/${tirzCd}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchTIRZTaxingUnits(
  { assessmentService },
  authenticationToken,
  { tirzCd },
) {
  const url = `${assessmentService}/assessment/tirz/${tirzCd}/taxingunits`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function addTIRZTaxingUnit(
  { assessmentService },
  authenticationToken,
  { tirzCd, payload },
) {
  const url = `${assessmentService}/assessment/tirz/${tirzCd}/taxingunits`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteTIRZTaxingUnit(
  { assessmentService },
  authenticationToken,
  { tirzTaxingUnitID },
) {
  const url = `${assessmentService}/assessment/tirz/taxingunit/${tirzTaxingUnitID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export const insertTIRZFile = async (
  { assessmentService },
  authenticationToken,
  { payload, tirzCd },
) => {
  const url = `${assessmentService}/assessment/tirz/${tirzCd}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const downloadTIRZFile = async (
  { assessmentService },
  authenticationToken,
  { tirzCd, s3ID },
) => {
  const url = `${assessmentService}/assessment/tirz/${tirzCd}/file/${s3ID}`;
  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then(response => response.blob())
    .then(blobby => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};
